import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookies from 'js-cookie'

import Auth from '@pages/auth/Auth.vue'
import Login from '@pages/auth/Login.vue'
import ForgotPassword from '@pages/auth/ForgotPassword.vue'
import ResetPassword from '@pages/auth/ResetPassword.vue'
import Home from '@pages/Home.vue'

import IntegrationLog from '@pages/IntegrationLog.vue'

import Customers from '@pages/customers/Index.vue'
import Customer from '@pages/customers/Show.vue'

import Suppliers from '@pages/suppliers/Index.vue'
import Supplier from '@pages/suppliers/Show.vue'

import Items from '@pages/items/Index.vue'
import Item from '@pages/items/Show.vue'

import Serials from '@pages/serials/Index.vue'

import Settings from '@pages/settings/Settings.vue'
import UserProfile from '@pages/settings/UserProfile.vue'
import Users from '@pages/settings/Users.vue';
import Integrations from '@pages/settings/Integrations.vue'
import PDF from "@pages/settings/PDF"
import InventorySettings from "@pages/settings/Inventory"
import Invoicing from '@pages/settings/Invoicing'
import ProjectSettings from '@pages/settings/ProjectSettings'

import Projects from '@pages/projects/Index.vue'
import ProjectView from '@pages/projects/View.vue'
import ProjectsOverview from '@pages/projects/Overview.vue'
import Dashboard from '@pages/dashboard/Index.vue'

import ReportView from '@pages/projects/reports/View.vue'

import store from '../store'

Vue.use(VueRouter)

const inventoryEnabled = Vue.prototype.$inventoryEnabled;

const router = new VueRouter({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/integrationlog',
            name: 'integrationlog',
            component: IntegrationLog,
        },
        {
            path: '/login',
            component: Auth,
            children: [
                {
                    path: '',
                    name: 'login',
                    component: Login
                },
                {
                    path: 'forgot-password',
                    name: 'forgot-password',
                    component: ForgotPassword
                },
                {
                    path: 'reset-password/:token',
                    name: 'reset-password',
                    component: ResetPassword
                }
            ]
        },
        {
            path: '/customers',
            name: 'customers',
            component: Customers,
        },
        {
            path: '/customers/:id',
            name: 'customer',
            component: Customer,
            props: true
        },
        {
            path: '/suppliers',
            name: 'suppliers',
            component: Suppliers,
            meta: { inventoryEnabled }
        },
        {
            path: '/items',
            name: 'item.index',
            component: Items,
            meta: { inventoryEnabled }
        },
        {
            path: '/items/:id',
            name: 'items',
            component: Item,
            props: true,
            meta: { inventoryEnabled }
        },
        {
            path: '/serials',
            name: 'serials',
            component: Serials,
            meta: { inventoryEnabled }
        },
        {
            path: '/projects',
            name: 'projects',
            component: Projects,
            redirect: { name: 'projects.overview' },
            children: [
                {
                    path: 'overview',
                    name: 'projects.overview',
                    component: ProjectsOverview,
                },
                {
                    path: 'new',
                    name: 'projects.new',
                    component: ProjectView,
                },
                {
                    path: ':id/reports/:reportid',
                    name: 'project.reports.edit',
                    component: ReportView,
                },
                {
                    path: ':id',
                    name: 'project.edit',
                    component: ProjectView,
                },
            ]
        },
        {
            path: '/rapporter',
            name: 'rapporter',
            component: Dashboard,
        },
        {
            path: '/settings',
            name: 'settings',
            component: Settings,
            redirect: { name: 'profile' },
            children: [
                {
                    path: 'profile',
                    name: 'profile',
                    component: UserProfile,
                },
                {
                    path: 'users',
                    name: 'users',
                    component: Users,
                },
                {
                    path: 'projects',
                    name: 'projects',
                    component: ProjectSettings,
                },
                {
                    path: 'integrations',
                    component: Integrations,
                },
                {
                    path: 'pdf',
                    component: PDF,
                },
                {
                    path: 'invoicing',
                    component: Invoicing,
                },
                {
                    path: 'inventory',
                    component: InventorySettings,
                    meta: { inventoryEnabled }
                },
            ]
        },
    ],
    mode: 'history',
    linkActiveClass: 'is-active',
})

const unauthedRoutes = [
    'login',
    'forgot-password',
    'reset-password'
]

const adminRoutes = [
    'rapporter'
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err) => {
    if (VueRouter.isNavigationFailure(err)) {
      // resolve err
      return err
    }
    // rethrow error
    return Promise.reject(err)
  })
}

router.beforeEach((to, _from, next) => {
    if (to.meta.enabled !== undefined) {
        if (!to.meta.inventoryEnabled) {
            return next({ name: 'home' })
        }
    }

    // Go to login page if no api_token in cookie
    if (unauthedRoutes.indexOf(to.name) !== -1 && !Cookies.get('api_token')) {
        return next()
    }

    // If logged in and not going to login page or admin routes: go ahead
    if (adminRoutes.indexOf(to.name) === -1 && unauthedRoutes.indexOf(to.name) === -1 && store.getters.authed) {
        return next()
    }

    // Attemt to auth with api_token from cookie
    store.dispatch('auth')
        .then((authed) => {
            // Go to login if auth unsuccessful
            if (!authed) {
                return next({ name: 'login' })
            }

            if(adminRoutes.indexOf(to.name) !== -1 && store.getters.isAdmin){
                return next()
            }

            // Cannot go to login page if authed
            if (to.name === 'login' || adminRoutes.indexOf(to.name) !== -1) {
                return next({ name: 'home' })
            }

            next()
        })
        .catch(() => next(false))
})

export default router
